import { transition, trigger, useAnimation } from '@angular/animations';
import { Component, Input } from '@angular/core';
import {
  fadeInStaticPositionAnimation,
  fadeOutStaticPositionAnimation,
} from '../../../../../shared/animations/index';
import { EntityDetailDisplayMode } from '../../../../../shared/definitions/entity-detail-display-mode.enum';
import { EntityDetailDividerStyle } from '../../../../../shared/definitions/entity-detail-divider-style.enum';
import { LoadingIndicatorStyles } from '../../../constants/loading-indicator-styles.constant';

@Component({
  selector: 'entity-detail',
  standalone: false,
  templateUrl: './entity-detail.component.html',
  styleUrls: ['./entity-detail.component.scss'],
  host: {
    class: 'angular-component-wrapper',
  },
  animations: [
    trigger('fadeInOutStaticPositionAnimation', [
      transition(':enter', [
        useAnimation(fadeInStaticPositionAnimation, {
          params: {
            duration: '0.2s',
            delay: '0s',
          },
        }),
      ]),
      transition(':leave', [
        useAnimation(fadeOutStaticPositionAnimation, {
          params: {
            duration: '0.2s',
            delay: '0s',
          },
        }),
      ]),
    ]),
  ],
})
export class EntityDetailComponent {
  @Input() displayMode: EntityDetailDisplayMode;

  @Input('initializing') currentlyInitializing: boolean;
  @Input() initializationErrorState: boolean;
  @Input() initializationErrorMessage: string =
    `An error has occurred, please contact SimX Support for assistance.`;

  loadingIndicatorStyles = LoadingIndicatorStyles;
  entityDetailDisplayMode = EntityDetailDisplayMode;
  entityDetailDividerStyle = EntityDetailDividerStyle;
}
